// extracted by mini-css-extract-plugin
export default {"value":"ProjectInfo_value__PcJM-","value1":"ProjectInfo_value1__OXpB2","wrapper":"ProjectInfo_wrapper__+JHG4"};